import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Button, 
  TextField,
  CardActions,
  Alert,
  Snackbar
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
import { useState } from 'react';

const ContactCard = ({ inFooter = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real implementation, you would send this data to your backend
    
    // Show success message
    setSnackbar({
      open: true,
      message: 'Message sent successfully! We will get back to you soon.',
      severity: 'success'
    });
    
    // Clear form
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({
      ...prev,
      open: false
    }));
  };

  // Styles for the footer version
  const footerStyles = {
    card: {
      bgcolor: 'transparent',
      color: 'white',
      border: 'none',
      boxShadow: 'none'
    },
    header: {
      bgcolor: 'rgba(255,255,255,0.1)',
      color: 'white'
    },
    input: {
      bgcolor: 'white',
      borderRadius: 1,
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'rgba(0,0,0,0.23)',
        },
        '&:hover fieldset': {
          borderColor: 'rgba(0,0,0,0.5)',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'primary.main',
        },
      },
      '& .MuiInputLabel-root': {
        color: 'rgba(0,0,0,0.7)',
      },
      '& .MuiOutlinedInput-input': {
        color: 'rgba(0,0,0,0.87)',
      },
    }
  };

  return (
    <>
      <Card
        elevation={0}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
          border: inFooter ? 'none' : '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
          ...(inFooter ? footerStyles.card : {})
        }}
      >
        <Box
          sx={{
            bgcolor: inFooter ? 'transparent' : 'primary.main',
            color: inFooter ? 'white' : 'primary.contrastText',
            py: 2,
            px: 3,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <EmailIcon sx={{ mr: 1.5 }} />
          <Typography variant="h6" component="h3">
            Contact Us
          </Typography>
        </Box>
        <CardContent sx={{ flexGrow: 1, pt: 3 }}>
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Name"
              margin="normal"
              variant="outlined"
              size="small"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              sx={inFooter ? footerStyles.input : {}}
            />
            <TextField
              fullWidth
              label="Email"
              margin="normal"
              variant="outlined"
              size="small"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              sx={inFooter ? footerStyles.input : {}}
            />
            <TextField
              fullWidth
              label="Message"
              margin="normal"
              variant="outlined"
              multiline
              rows={3}
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              sx={inFooter ? footerStyles.input : {}}
            />
            <CardActions sx={{ justifyContent: 'flex-end', px: 0, pt: 2 }}>
              <Button 
                type="submit" 
                variant={inFooter ? "outlined" : "contained"}
                endIcon={<SendIcon />}
                color={inFooter ? "inherit" : "primary"}
                sx={inFooter ? { borderColor: 'rgba(255,255,255,0.5)' } : {}}
              >
                Send Message
              </Button>
            </CardActions>
          </form>
        </CardContent>
      </Card>
      
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity} 
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ContactCard; 